import { render, staticRenderFns } from "./DeliverySpeed.vue?vue&type=template&id=4919c75a&"
import script from "./DeliverySpeed.vue?vue&type=script&lang=js&"
export * from "./DeliverySpeed.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySpeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports